import { createSlice } from '@reduxjs/toolkit';

type CtaButtonState = {
    display: boolean;
};

const initialState: CtaButtonState = {
    display: true,
};

export const ctaButtonSlice = createSlice({
    name: 'root/ctaButton',
    initialState,
    reducers: {
        setCtaButton: (state, action) => (state = action.payload),
    },
});
